<template lang="html">
  <div v-if="visible" :class="{dark: darkmode}" class="add-edit-todo">
    <AveInput :darkmode="darkmode" :error="errorTask" @focussed="errorTask=''" icon="task" :placeholder="currentTask" v-model="inputTask" />
    <AveInput :darkmode="darkmode" :error="errorTime"  @focussed="errorTime=''" icon="timetracking" :placeholder="currentTime" v-model="inputTimetracking"/>
    <AveInput :darkmode="darkmode" :error="errorDonetime" @focussed="errorDonetime=''" icon="donetimeplus" :placeholder="currentDonetime"  v-if="type !== 'add'" v-model="inputDonetime" />
    <AveInput :darkmode="darkmode" :error="errorLabel" @focussed="errorLabel=''" icon="label" :placeholder="currentLabel" v-model="inputLabel"/>
    <div class="container">
      <AveButton  @click="hideDelete" :darkmode="darkmode" icon="wrong" icon-type="negative" :label="label"/>
      <div class="gap"></div>
      <AveButton @click="addEdit" :darkmode="darkmode" icon="done" icon-type="positive" label="Done"/>
    </div>
  </div>
</template>

<script>
import AveInput from '@/components/AveInput.vue';
import AveButton from '@/components/AveButton.vue';

export default {
  components: {
    AveInput,
    AveButton,
  },
  data() {
    return {
      inputTask: '',
      inputTimetracking: '',
      inputDonetime: '',
      inputLabel: '',
      errorTask: '',
      errorTime: '',
      errorDonetime: '',
      errorLabel: '',
    };
  },
  methods: {
    addEdit() {
      // Zeit holen um zu schauen, ob es einen Fehler gibt

      // Wenn fehler auftauchen:
      if (this.type === 'add') {
        const inputTime = this.parseInputToMilli(this.inputTimetracking, 'time');
        if (!this.inputTask) {
          this.errorTask = 'You have to add a title for your to do!';
        }
        if (!this.inputTimetracking) {
          this.errorTime = 'You need to estimate how long this task will take you to complete!';
        }
        if (!this.inputLabel) {
          this.errorLabel = 'You need to add a specific label that defines your task!';
        }
        // if(Number.isNan(Number.parseInt(this.TimeTracking, 10))){
        //
        // }
        // Wenn alles ok ist dann Lade es hoch
        if (this.inputTask && this.inputTimetracking && this.inputLabel && !this.errorTime) {
          const currentDate = new Date();
          const dd = String(currentDate.getDate()).padStart(2, '0');
          const mm = String(currentDate.getMonth() + 1).padStart(2, '0');
          const yyyy = currentDate.getFullYear();
          const todoDate = `${dd}.${mm}.${yyyy}`;
          const data = {
            // title: this.inputTask, time: Number.parseInt(this.inputTimetracking, 10), label: `#${this.inputLabel}`, creationDate: todoDate,
            title: this.inputTask, time: inputTime, label: `#${this.inputLabel}`, creationDate: todoDate,
          };
          this.$emit('emitInputs', data);
          this.inputTask = '';
          this.inputTimetracking = '';
          this.inputLabel = '';
          this.errorTask = '';
          this.errorTime = '';
          this.errorLabel = '';
        }
      } else {
        let inputTime = NaN;
        let inputDonetime = NaN;
        if (this.inputTimetracking) {
          inputTime = this.parseInputToMilli(this.inputTimetracking, 'time');
          // console.log(inputTime);
        }
        if (this.inputDonetime) {
          inputDonetime = this.parseInputToMilli(this.inputDonetime, 'donetime');
          // console.log(inputDonetime);
        }
        if (!this.errorTime && !this.errorDonetime) {
          const data = {
            // title: this.inputTask, time: Number.parseInt(this.inputTimetracking, 10), label: `#${this.inputLabel}`, creationDate: todoDate,
            title: this.inputTask, time: inputTime, donetime: inputDonetime, label: `#${this.inputLabel}`,
          };
          this.$emit('emitInputs', data);
          this.inputTask = '';
          this.inputTimetracking = '';
          this.inputDonetime = '';
          this.inputLabel = '';
          // console.log(data);
        }
      }
    },

    hideDelete() {
      this.inputTask = '';
      this.inputTimetracking = '';
      this.inputLabel = '';
      this.$emit('hideDelete');
    },

    parseInputToMilli(input, source) {
      // Eingabe 10:20 Alles vor : ist Stunde alles danach ist Minute
      // Eingabe 10 20 Alles vor "" ist Stunde alles danach ist Minute
      // Eingabe 10 Alles ist Stunde
      if (input.includes(':')) {
        // console.log('Eingabe im Format 10:20');
        const str = input.split(':');
        // console.log(str);
        return Number.parseInt(str[0], 10) * 3600000 + Number.parseInt(str[1], 10) * 60000;
      } if (input.includes(' ')) {
        // console.log('Eingabe im Format 10 20');
        const str = input.split(' ');
        // console.log(str);
        return Number.parseInt(str[0], 10) * 3600000 + Number.parseInt(str[1], 10) * 60000;
      }
      if (input.includes(',')) {
        const str = input.split(',');
        // console.log(str);
        // Schauen auf wie viele Kommastellen gerundet wird
        if (str[1].length === 1) {
          return Number.parseInt(str[0], 10) * 3600000 + ((Number.parseInt(str[1], 10) / 10) * 3600000);
        }
        const twodigits = str[1].substring(0, 2);
        return Number.parseInt(str[0], 10) * 3600000 + ((Number.parseInt(twodigits, 100) / 10) * 3600000);
      }
      // // console.log(Number.parseInt(str[0], 10) * 3600000 + ((Number.parseInt(str[1], 10) / 100) * 3600000));
      if (!Number.isNaN(Number.parseInt(input, 10))) {
        // console.log('Eingabe im Format 10');
        const str = input;
        // console.log(str);
        return Number.parseInt(str, 10) * 3600000;
      }
      if (source === 'time') {
        this.errorTime = 'Plaease use a valid format to estimate duration, (h:m/h m/h)';
      }
      if (source === 'donetime') {
        this.errorDonetime = 'Plaease use a valid format to estimate duration, (h:m/h m/h)';
      }
      return NaN;
    },

  },
  props: {
    type: String,
    darkmode: Boolean,
    visible: Boolean,
    label: String,

    currentDonetime: {
      type: String,
      default: 'ups',
    },

    currentTask: {
      type: String,
      default: 'Task, To Do,...',
    },
    currentTime: {
      type: String,
      default: '10 hours, 10:00h, 2400 min,...',
    },
    currentLabel: {
      type: String,
      default: 'label1, label2, label3,...',
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'
h3
  margin: 0

  &.addTaskHead
    margin: 0
    margin-bottom: 3px
    font-size: 19px
    font-weight: 600;
p
  margin 0

  &.addText
    margin: 0
    font-size: 11px
    font-weight: 600
    line-height: 152.8%

.addtodo
  width 100%
  position relative
  left -10px
  display flex
  align-items: center
  background-color: $white
  padding: 12px 0
  margin-bottom $marginBottom

  :hover
    cursor: pointer

  &.dark
    background-color: $normal
    color $darkmodeWhite

.icon
  margin-right: 13px
  margin-left: 23px

.container
  display flex
  flex-direction row

  .gap
    width: 25px
</style>
